export default __webpack_public_path__ + "static/stacked-area-8299a6c2ca41c18528c26bab8f164ac1.png";